export enum GtagDevices {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
}

export enum GtagFrom {
  MAIN = 'main',
  PICKER = 'picker',
  YELLOW_BANNER = 'yellow_banner',
  WHITE_BANNER = 'white_banner',
  BUSINESS = 'business',
}

export interface IBlockWithButton {
  onBtnClick: () => void;
}

export interface IBlockWithDevice {
  device: GtagDevices;
}
